export default __webpack_public_path__ + "static/BrandonGrotesque-Bold-80349bb3518deacca0c28e3e5137e1f0.woff2";